const FINAL_TRANSACTION_STATUSES = new Set([
  'approved',
  'canceled',
  'cancelled',
  'completed',
  'declined',
  'error',
  'failed',
  'rejected',
  'resolution',
  'succeed',
]);

export function isFinalTransactionStatus(statusValue) {
  const status = String(statusValue || '').trim().toLowerCase();
  return FINAL_TRANSACTION_STATUSES.has(status);
}

export function getTransactionStatusBadgeClass(statusValue) {
  const status = String(statusValue || '').trim().toLowerCase();

  if (status === 'approved') {
    return 'bg-success-subtle text-success';
  }

  if (status === 'error' || status === 'failed') {
    return 'bg-danger-subtle text-danger';
  }

  if (status === 'processed') {
    return 'bg-primary-subtle text-primary';
  }

  return 'bg-secondary-subtle text-secondary';
}
